export default function PrivacyPolicy() {
  return (
    <main data-testid="page-privacy-policy" style={{ padding: "140px 0 100px" }}>
      <section className="container-narrow">
        <span className="eyebrow">Privacy policy</span>
        <h1 style={{ fontSize: "clamp(40px, 5vw, 64px)", marginTop: 22, marginBottom: 18, lineHeight: 1.02 }}>
          Privacy Policy for CRAM Finance
        </h1>
        <p style={{ fontSize: 16, color: "var(--t2)", marginBottom: 10 }}><strong>Effective Date:</strong> August 31st, 2026</p>
        <p style={{ fontSize: 18, color: "var(--t2)", marginBottom: 40 }}>
          Your privacy matters. We don't sell your data. Here's how we handle the information we collect. CRAM Finance is dedicated to providing clear, transparent resources for students navigating financial products without compromising your digital footprint.
        </p>

        <div style={{ marginBottom: 32 }}>
          <h2 style={{ fontFamily: "Fraunces, serif", fontSize: 26, marginBottom: 10 }}>1. Our Commitment to Your Privacy</h2>
          <p style={{ color: "var(--t2)", fontSize: 16, lineHeight: 1.7 }}>
            Your privacy matters. We don't sell your data. Here's how we handle the information we collect. CRAM Finance is dedicated to providing clear, transparent resources for students navigating financial products without compromising your digital footprint.
          </p>
        </div>

        <div style={{ marginBottom: 32 }}>
          <h2 style={{ fontFamily: "Fraunces, serif", fontSize: 26, marginBottom: 10 }}>2. What We Collect</h2>
          <p style={{ color: "var(--t2)", fontSize: 16, lineHeight: 1.7 }}>
            Only the minimum needed to run the site: anonymous analytics and any contact form submissions you choose to send.
          </p>
          <ul style={{ color: "var(--t2)", fontSize: 16, lineHeight: 1.7, paddingLeft: 20, marginTop: 10 }}>
            <li><strong>Personal Information:</strong> This is strictly limited to information you voluntarily provide to us via our contact form, such as your name and email address.</li>
            <li><strong>Usage Data:</strong> We collect anonymous browser analytics automatically as you navigate through the platform.</li>
          </ul>
        </div>

        <div style={{ marginBottom: 32 }}>
          <h2 style={{ fontFamily: "Fraunces, serif", fontSize: 26, marginBottom: 10 }}>3. How We Use It</h2>
          <p style={{ color: "var(--t2)", fontSize: 16, lineHeight: 1.7 }}>
            Analytics help us understand what students need so we can improve the site. Contact submissions are used only to reply to you and address your specific inquiries. We do not use your contact information for unsolicited marketing or advertising campaigns.
          </p>
        </div>

        <div style={{ marginBottom: 32 }}>
          <h2 style={{ fontFamily: "Fraunces, serif", fontSize: 26, marginBottom: 10 }}>4. Third-Party Data Processors</h2>
          <p style={{ color: "var(--t2)", fontSize: 16, lineHeight: 1.7 }}>
            To maintain an efficient, reliable website infrastructure, we securely partner with trusted third-party developer services. Your data passes through:
          </p>
          <ul style={{ color: "var(--t2)", fontSize: 16, lineHeight: 1.7, paddingLeft: 20, marginTop: 10 }}>
            <li><strong>Cloudflare:</strong> For global web hosting, performance optimization, and anonymous firewall analytics.</li>
            <li><strong>EmailJS &amp; Brevo:</strong> For handling secure transfers and message delivery infrastructure when you submit our contact forms.</li>
          </ul>
          <p style={{ color: "var(--t2)", fontSize: 16, lineHeight: 1.7, marginTop: 10 }}>
            These processors are contractually or legally barred from using your data for any independent marketing purposes.
          </p>
        </div>

        <div style={{ marginBottom: 32 }}>
          <h2 style={{ fontFamily: "Fraunces, serif", fontSize: 26, marginBottom: 10 }}>5. Your Choices and Rights</h2>
          <p style={{ color: "var(--t2)", fontSize: 16, lineHeight: 1.7 }}>
            You can use browser privacy controls, ad blockers, or Do Not Track settings to opt out of analytics any time.
          </p>
          <p style={{ color: "var(--t2)", fontSize: 16, lineHeight: 1.7, marginTop: 10 }}>
            Additionally, under applicable privacy frameworks (including California's CCPA/CPRA), you have the right to request access to, correction of, or permanent deletion of any personal data you have transmitted through our forms. To exercise these consumer privacy rights, please contact our support desk directly at: contact@cramfinance.org.
          </p>
        </div>
      </section>
    </main>
  );
}
